/**
 * @architecture-header 1
 * @layer module
 * @domain classrooms
 * @responsibility Validate create, update, and join Classroom form values.
 * @state-owner React Hook Form consumers
 * @allowed-imports Zod
 * @forbidden components; routes; API clients
 * @public-api classrooms module forms
 * @side-effects none
 * @tests modules/classrooms/model/next-lesson.test.ts and module-contracts.test.ts
 */

import { z } from 'zod';

export const createClassSchema = z.object({
  name: z.string().trim().min(2, '請輸入至少 2 個字的班級名稱').max(160, '班級名稱過長'),
  subject: z.string().trim().max(160, '科目名稱過長').optional(),
});

export const updateClassroomSchema = createClassSchema.extend({
  subject: z.string().trim().max(160, '科目名稱過長'),
});

export const joinClassSchema = z.object({
  joinCode: z
    .string()
    .trim()
    .min(4, '請輸入班級代碼')
    .transform((value) => value.toUpperCase()),
});

export type CreateClassValues = z.infer<typeof createClassSchema>;
export type UpdateClassroomValues = z.infer<typeof updateClassroomSchema>;
export type JoinClassValues = z.input<typeof joinClassSchema>;
